export default "__VITE_ASSET__f339a435__"